import * as Yup from "yup"
import { LogError } from "../logger"

export default function validation_assessments(fieldName, acc) {
  Yup.addMethod(Yup.string, "validateAssessments", function (errorMessage) {
    return this.test(`validateAssessments`, errorMessage, function (value) {
      const { path, createError } = this

      if (value) {
        const values = JSON.parse(value)

        try {
          if (values.length > 0) {
            if (
              values.some(
                (assessment) =>
                  assessment.required && !assessment.completed_assessment_id
              )
            ) {
              return createError({
                path,
                message: "All required assessments need to be completed",
              })
            }
          }

          return true
        } catch (error) {
          LogError(
            "validation_assessments: Unable to validate assessments",
            error
          )
          return createError({
            path,
            message: "Unable to validate assessments form",
          })
        }
      } else {
        return true
      }
    })
  })

  return {
    [fieldName]: Yup.string().validateAssessments(),
    ...acc,
  }
}
